import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface SowPrdRow {
  id: number;
  uuid: string;
  document_type: 'SOW' | 'PRD';
  name: string;
  project_id: number;
  project_name: string;
  project_uuid: string;
  request_ids: string | null;
  account_owner_email: string | null;
  created_at: string;
  last_downloaded_at: string | null;
  has_content: boolean;
}

interface SowPrdListResponse {
  success: boolean;
  data: SowPrdRow[];
  meta?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

interface SowPrdContentResponse {
  success: boolean;
  data?: {
    uuid: string;
    name: string;
    document_type: 'SOW' | 'PRD';
    content: string;
  };
  message?: string;
}

interface ListParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const sowPrdApi = createApi({
  reducerPath: 'sowPrdApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/admin/sow-prd',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['SowPrd'],
  endpoints: (builder) => ({
    listSowPrd: builder.query<SowPrdListResponse, ListParams | void>({
      query: (params = {}) => ({
        url: '/',
        params: { page: params?.page ?? 1, limit: params?.limit ?? 50, search: params?.search ?? '' },
      }),
      providesTags: ['SowPrd'],
    }),
    getSowPrdContent: builder.query<SowPrdContentResponse, string>({
      query: (uuid) => `/${uuid}/content`,
      providesTags: (_result, _err, uuid) => [{ type: 'SowPrd', id: uuid }],
    }),
  }),
});

export const { useListSowPrdQuery, useGetSowPrdContentQuery, useLazyGetSowPrdContentQuery } = sowPrdApi;
